"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuSelectLink = void 0;
var tslib_1 = require("tslib");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_helper_hooks_1 = require("@hopin-team/ui-helper-hooks");
var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");
var ui_icon_1 = require("@hopin-team/ui-icon");
var react_1 = tslib_1.__importStar(require("react"));
var context_1 = require("../context");
var select_link_1 = require("../styled/select-link");
var MenuSelectLink = function (_a) {
    var __UIScope = _a.__UIScope, testID = _a["data-testid"], className = _a.className, itemUrl = _a.itemUrl, label = _a.label, leadingIcon = _a.leadingIcon, trailingIcon = _a.trailingIcon, download = _a.download, rel = _a.rel, target = _a.target, disabled = _a.disabled, props = tslib_1.__rest(_a, ["__UIScope", 'data-testid', "className", "itemUrl", "label", "leadingIcon", "trailingIcon", "download", "rel", "target", "disabled"]);
    var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
        block: 'MenuSelectLink',
        className: className,
        __UIScope: __UIScope,
    }).rootClasses;
    var _b = (0, react_1.useContext)(context_1.MenuContext), onClose = _b.onClose, isInverse = _b.isInverse;
    var iconColor = (0, react_1.useMemo)(function () {
        if (disabled)
            return isInverse ? 'grey-400' : 'grey-600';
        return isInverse ? 'grey-white' : 'grey-dark';
    }, [disabled, isInverse]);
    (0, ui_helper_hooks_1.useOnKeyPress)('Escape', onClose);
    return (react_1.default.createElement(select_link_1.SelectLink, tslib_1.__assign({ className: rootClasses, "data-testid": testID, role: "menuitem", href: !disabled ? itemUrl : undefined, download: download, rel: rel, target: target, tabIndex: -1, isInverse: isInverse, "aria-disabled": !!disabled }, props),
        leadingIcon && (react_1.default.createElement(ui_icon_1.Icon, { name: leadingIcon, "aria-hidden": true, color: iconColor })),
        react_1.default.createElement(select_link_1.SelectLinkContent, null, label),
        trailingIcon && (react_1.default.createElement(ui_icon_1.Icon, { ml: 1, name: trailingIcon, "aria-hidden": true, color: iconColor }))));
};
var MenuSelectLinkWithSpace = (0, ui_helper_with_space_1.withSpace)(MenuSelectLink);
exports.MenuSelectLink = MenuSelectLinkWithSpace;
//# sourceMappingURL=menu-select-link.js.map